//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue'
// import { MODES } from './RequestWorkTypeReportInclusionMode.js'
import RequestWorkTypes from './RequestWorkTypes.vue'
import RequestAutoAssignWorkTypes from './RequestAutoAssignWorkTypes.vue'
import ReportContentSection from '../Report/ReportContent/ReportContentSection.vue'

const SYNCED_KEYS = ['includedInCurrentReport', 'done', 'hasDoneReports', 'hasDoneMultipleReports', 'hasDonePartiallyReports', 'donePartiallyIsLast', 'inclusionMode', 'lastAppliedInclusionMode']

export default {
  name: 'RequestWorksSection',
  components: {
    RequestWorkTypes,
    RequestAutoAssignWorkTypes,
    ReportContentSection
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    requestInitial: {
      type: Object,
      default () {
        return {}
      }
    },
    taskStatus: {
      type: String,
      default () {
        return ''
      }
    },
    requestRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    availableWorkTypes: {
      type: Array,
      default () {
        return []
      }
    },
    isInitialize: {
      type: Boolean,
      default: false
    },
    isAudit: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    isAdditionalDepartureForm: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      expandedWorksScope: true,
      expandedContractorWorksScope: true,
      expandedAutoAssignWorksScope: true
    }
  },
  methods: {
    onChangeWorks: function (event) {
      if (event.newWorkTypes) {
        event.newWorkTypes.forEach(newWT => {
          const sourceWorkType = this.request.workPackages.map(wP => wP.workTypes).flat()
            .find(wT => wT.id === newWT.id)
          if (sourceWorkType) {
            this.setNewWorkTypeParams(newWT, sourceWorkType)
          } else if (!this.request.workTypes.map(wT => wT.id).includes(newWT.id)) {
            newWT.includedInCurrentReport = !!this.request.hasNotReadyReport
          }
        })
      } else if (event.newWorkPackages) {
        const sourceWorkTypes = this.request.workTypes
        const newWorkTypes = [...event.newWorkPackages.map(wP => wP.workTypes).flat()]
        newWorkTypes.forEach(newWT => {
          const sourceWorkType = sourceWorkTypes.find(sW => sW.id === newWT.id)
          // const sourceWorkTypeIndex = sourceWorkTypes.findIndex(sW => sW.id === newWT.id)
          if (sourceWorkType) {
            newWT.standalone = true
            this.setNewWorkTypeParams(newWT, sourceWorkType)
            // if (!sourceWorkType.reportsHasStandaloneDoneResult) {
            //   this.request.workTypes = this.request.workTypes.toSpliced(sourceWorkTypeIndex, 1)
            //   newWT.standalone = false
            // }
          } else {
            newWT.includedInCurrentReport = !!this.request.hasNotReadyReport
          }
        })
      } else if (event.changedWorkType) {
        this.syncWorkTypes(event.changedWorkType, [
          ...this.request.workTypes,
          ...this.request.workPackages.map(wP => wP.workTypes).flat()
        ])
      }
    },
    onChangeContractorWorks: function (event) {
      if (event.newWorkTypes) {
        event.newWorkTypes.forEach(newWT => {
          const sourceWorkType = this.request.workPackagesContractor.map(wP => wP.workTypes).flat()
            .find(wT => wT.id === newWT.id)
          if (sourceWorkType) {
            this.setNewWorkTypeParams(newWT, sourceWorkType)
          }
        })
      } else if (event.newWorkPackages) {
        const sourceWorkTypes = this.request.workTypesContractor
        const newWorkTypes = [...event.newWorkPackages.map(wP => wP.workTypes).flat()]
        newWorkTypes.forEach(newWT => {
          const sourceWorkType = sourceWorkTypes.find(sW => sW.id === newWT.id)
          // const sourceWorkTypeIndex = sourceWorkTypes.findIndex(sW => sW.id === newWT.id)
          if (sourceWorkType) {
            this.setNewWorkTypeParams(newWT, sourceWorkType)
            // if (!sourceWorkType.reportsHasStandaloneDoneResult) {
            //   this.request.workTypesContractor = this.request.workTypesContractor.toSpliced(sourceWorkTypeIndex, 1)
            //   newWT.standalone = false
            // }
          }
        })
      } else if (event.changedWorkType) {
        this.syncWorkTypes(event.changedWorkType, [
          ...this.request.workTypesContractor,
          ...this.request.workPackagesContractor.map(wP => wP.workTypes).flat()
        ])
      }
    },
    syncWorkTypes: function (changedWorkType, workTypes) {
      workTypes = workTypes.map(wT => {
        if (wT.id === changedWorkType.id) {
          SYNCED_KEYS.forEach(key => {
            Vue.set(wT, key, changedWorkType[key])
          })
        }
      })
    },
    setNewWorkTypeParams: function (newWorkType, sourceWorkType) {
      SYNCED_KEYS.forEach(key => {
        Vue.set(newWorkType, key, sourceWorkType[key])
      })
      // required, resultsRequired для каждой технологической операции
      newWorkType.technologicalOperations.forEach(technologicalOperation => {
        const changedTechnologicalOperation = sourceWorkType.technologicalOperations.find(tO => tO.id === technologicalOperation.id)
        if (changedTechnologicalOperation) {
          technologicalOperation.required = changedTechnologicalOperation.required
          technologicalOperation.resultsRequired = changedTechnologicalOperation.resultsRequired
        }
      })
    }
  }
}
